import { connect } from 'react-redux';
import { userActions } from '../../actions';
import ResetPassword from '../../components/public/ResetPassword';

const mapDispatchToProps = (dispatch) => {
  return {
    resetPassword: (values) => { dispatch(userActions.resetPassword(values)) },
  }
}

function mapStateToProps(state, ownProps) {
	const { message, type } = state.alerts;
    
  return {
    alertMessage: message,
    alertType: type,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ResetPassword);